<template>
  <div>
    <van-nav-bar
        title="报名人员信息详情"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    />

    <van-cell-group>
      <van-cell title="证件种类" :value="minute.speciesName"/>
      <van-cell title="作业类别" :value="minute.projectName"/>
      <van-cell title="准操项目" :value="minute.courseName"/>
      <van-cell title="课训种类" :value="minute.ltchoose"/>
      <van-cell title="性别" :value="minute.sex"/>
      <van-cell title="学历" :value="minute.education"/>
      <van-cell title="姓名" :value="minute.name"/>
      <van-cell title="单位" :value="minute.dept"/>
      <van-cell title="手机" :value="minute.phone"/>
      <van-cell title="原证件编号" :value="minute.cardNumber"/>
      <van-cell title="报名时间" :value="minute.time.substring(0, 10)"/>
      <van-cell title="是否缴费" :value="minute.isPay === 'true' ? '已缴费':'未缴费'"/>
      <van-cell title="缴费金额" :value="minute.money"/>

      <div class="image-title">身份证</div>
      <div class="image">
        <van-image
            v-for="(item,index) in cardList"
            width="100"
            :key="index"
            height="100"
            :src="item"
            @click="openBigImage(item)"
        />
      </div>

      <div class="image-title" v-if="minute.ltchoose === '复训'">复训证</div>
      <div class="image" v-if="minute.ltchoose === '复训'">
        <!--        <van-uploader v-model="retrainList" :show-upload="false" :deletable="false"/>-->
        <van-image
            v-for="(item,index) in retrainList"
            width="100"
            :key="index"
            height="100"
            :src="item"
            @click="openBigImage(item)"
        />
      </div>

      <div class="image-title">学历证明照片(初中以上)</div>
      <div class="image">
        <!--        <van-uploader v-model="poqList" :show-upload="false" :deletable="false"/>-->
        <van-image
            v-for="(item,index) in poqList"
            width="100"
            :key="index"
            height="100"
            :src="item"
            @click="openBigImage(item)"
        />
      </div>

      <div class="image-title">电子证件照(本人照片)</div>
      <div class="image">
        <!--        <van-uploader v-model="healthBookList" :show-upload="false" :deletable="false"/>-->
        <van-image
            v-for="(item,index) in healthBookList"
            width="100"
            :key="index"
            height="100"
            :src="item"
            @click="openBigImage(item)"
        />
      </div>

    </van-cell-group>
  </div>
</template>

<script>
import {onBeforeMount, ref} from "vue";
import {useRoute, useRouter} from "vue-router";
import axios from "../../api/http";
import {ImagePreview} from "vant";

export default {
  name: "registerMinute",
  components: {
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const minute = ref({});

    const cardList = ref([]);
    const poqList = ref([])
    const healthBookList = ref([])
    const retrainList = ref([])

    function onClickLeft() {
      router.back();
    }

    onBeforeMount(() => {
      minute.value = route.params;
      cardList.value = [
        window.configs.baseUrl + "/Upload/" + minute.value.id + "/" + minute.value.cardNegative,
        window.configs.baseUrl + "/Upload/" + minute.value.id + "/" + minute.value.cardPositive,
      ]
      retrainList.value = [
        window.configs.baseUrl + "/Upload/" + minute.value.id + "/" + minute.value.retrainNegative,
        window.configs.baseUrl + "/Upload/" + minute.value.id + "/" + minute.value.retrainPositive,
      ]
      poqList.value = [
        window.configs.baseUrl + '/Upload/' + minute.value.id + '/' + minute.value.poq,
      ]
      healthBookList.value = [
        window.configs.baseUrl + '/Upload/' + minute.value.id + '/' + minute.value.healthBook,
      ]
    });

    function openBigImage(image) {
      ImagePreview({images: [image], closeable: true})
    }

    return {onClickLeft, minute, axios, cardList, poqList, healthBookList, retrainList, openBigImage};
  }
};
</script>

<style scoped>
.image-title {
  margin-bottom: 20px;
}

.image {
  display: flex;
  justify-content: space-around;
  margin-bottom: 20px;
}
</style>
